var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTemplateframe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1334 2H3.46672C3.09853 2 2.80005 2.29848 2.80005 2.66667V6C2.80005 6.36819 3.09853 6.66667 3.46672 6.66667H14.1334C14.5016 6.66667 14.8 6.36819 14.8 6V2.66667C14.8 2.29848 14.5016 2 14.1334 2Z",
    fill: "white",
    stroke: "#172B4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.80005 9.33325H3.46672C3.09853 9.33325 2.80005 9.63173 2.80005 9.99992V13.3333C2.80005 13.7014 3.09853 13.9999 3.46672 13.9999H6.80005C7.16824 13.9999 7.46672 13.7014 7.46672 13.3333V9.99992C7.46672 9.63173 7.16824 9.33325 6.80005 9.33325Z",
    fill: "white",
    stroke: "#172B4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1334 9.33325H10.8001C10.4319 9.33325 10.1334 9.63173 10.1334 9.99992V13.3333C10.1334 13.7014 10.4319 13.9999 10.8001 13.9999H14.1334C14.5016 13.9999 14.8001 13.7014 14.8001 13.3333V9.99992C14.8001 9.63173 14.5016 9.33325 14.1334 9.33325Z",
    fill: "white",
    stroke: "#172B4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemplateframe);
export default __webpack_public_path__ + "static/media/Templateframe.517a773e330742b755afa4b17b22b66d.svg";
export { ForwardRef as ReactComponent };